import React, { createContext, useContext } from "react";
import { useDotLegalQueryWithKey } from "@common/hooks/dotLegalReactQuery";
import { usePermissionsProvider } from "../../../auth/usePermissionsProvider";
import { RiskAreaAssessmentLevel } from "../../../riskSettings/riskArea/riskAreaDialog/RiskAreaDialog.types";

export interface RiskAreaMenuItem {
    id: string;
    name: string;
    // Decides which tables the area's operational page shows: entities, the organisation as a whole, or both.
    assessmentLevel: RiskAreaAssessmentLevel;
}

export interface RiskAreasModel {
    riskAreas: Array<RiskAreaMenuItem>;
    isLoading: boolean;
}

const oneHour = 3600000;

export const RiskAreasContext = createContext<RiskAreasModel>({
    riskAreas: [],
    isLoading: false,
});

export const useRiskAreasContext = () => useContext(RiskAreasContext);

export interface IRiskAreasProviderProps {
    children: React.ReactNode;
}

export function RiskAreasProvider(props: IRiskAreasProviderProps) {
    const { hasEnterpriseRiskManagementAccess } = usePermissionsProvider();

    const { isLoading, data } = useDotLegalQueryWithKey<Array<RiskAreaMenuItem>>("riskAreasMenu", "/risk-areas/menu-items", {
        enabled: hasEnterpriseRiskManagementAccess,
        staleTime: oneHour,
        refetchOnWindowFocus: false,
        refetchInterval: false,
    });

    const contextData: RiskAreasModel = {
        riskAreas: data ?? [],
        isLoading,
    };

    return <RiskAreasContext.Provider value={contextData}>{props.children}</RiskAreasContext.Provider>;
}

export default RiskAreasProvider;
